<template>
  <div>
    <pdfStamp
      v-if="pdfUrl"
      ref="pdf"
      v-loading="loading"
      v-bind="bind"
      :resize="false"
      element-loading-text="正在加载文件..."
      confirm-text="提交"
      element-loading-background="#fff8"
    >
      <template #header>
        <div class="file-bar">
          <el-tabs class="file-list" size="mini" :value="curFileId" @input="setFileId">
            <el-tab-pane v-for="(file, index) in fileList" :key="index" :label="file.fileName" :name="file.fileId"></el-tab-pane>
          </el-tabs>
        </div>
        <el-radio-group :key="key" size="small" type="primary" :value="signType" class="sealPosition" @input="handleSealPositionChanged">
          <el-radio-button v-for="{ id, cnName } in sealPositionDict" :key="id" :label="id">{{ cnName }}</el-radio-button>
        </el-radio-group>
      </template>
      <template #footer="{ pdf }">
        <template v-if="(pdf && !isWebPdfSign) || (pdf && !butDisabled)">
          <el-button :disabled="butDisabled" plain size="small" type="primary" @click="$refs.pdf.handleSubmit(0)"> 签章（不用证书）</el-button>
          <el-button :disabled="butDisabled" size="small" type="primary" @click="$refs.pdf.handleSubmit(1)"> 签章（使用证书）</el-button>
        </template>
        <template v-if="pdf && butDisabled && isWebPdfSign">
          <el-button size="small" type="primary" @click="onLineFiles"> 查看文件</el-button>
          <el-button size="small" type="primary" @click="toProjectDoc"> 打开所在目录</el-button>
        </template>
      </template>
    </pdfStamp>
    <el-dialog v-dialogDrag width="700px" title="批量处理" :visible.sync="showBatch" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-checkbox v-model="isBothBatch">全选</el-checkbox>
      <el-checkbox-group v-model="batchId" size="small" style="height: 300px; overflow: auto">
        <el-checkbox v-for="{ waitFileId, waitFileName, hasSeal } in waitCopyList" :key="waitFileId" :label="waitFileId">
          {{ waitFileName }}<span v-if="hasSeal" class="seal-tag">已处理</span>
        </el-checkbox>
      </el-checkbox-group>
      <template slot="footer">
        <el-button size="small" @click="closeBatch">关闭</el-button>
        <el-button size="small" type="primary" @click="confirmBatch">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { addParamToUrl, getToken } from "@/CommonDP/utils";
import { cloneDeep, memoize } from "lodash-es";
import eSealService from "@/CommonDP/service/eSeal-service";
import { mapState } from "vuex";
import { noLabelFilePreview } from "@/CommonDP/utils/docPublic";
import flowService from "@/CommonDP/service/flow-service";
// 使用此方法的返回数据将被缓存
const cacheFn = memoize((url) => fetch(url).then((res) => res.arrayBuffer()));
export default {
  components: {
    pdfStamp: () => import("./extend.vue")
  },
  props: {
    isWebPdfSign: {
      type: Boolean,
      default: false
    },
    webSaveFolderId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      key: 0,
      butDisabled: false,
      realPdfTotal: 1,
      pdfUrl: "",
      prjId: "",
      fileName: "",
      stampList: [], // 侧边签章图片列表
      signType: 3, // 签章策略
      loading: true,
      curFileId: "",
      fileIdArray: [],
      fileList: [],
      sealPositionDict: [
        { cnName: "仅在首页盖章", id: 1 },
        { cnName: "首页与末页盖章", id: 2 },
        { cnName: "在自选页盖章", id: 3 } // 手动盖章
      ],
      showBatch: false,
      batchId: [],
      filesList: []
    };
  },
  computed: {
    ...mapState({
      webEnterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    saveFolderId() {
      return this.$route.query.saveFolderId || this.webSaveFolderId || "";
    },
    projectId() {
      return this.$route.query.prjId || this.prjInfo.prjId || "";
    },
    enterpriseId() {
      return this.$route.query.enterpriseId || this.webEnterpriseId || "";
    },
    bind() {
      const { queryStamp, getPdf, onSubmit, getCache, onPageUpdate } = this;
      return {
        queryStamp,
        getPdf,
        onSubmit,
        getCache,
        onPageUpdate
      };
    },
    onlyFirst() {
      return this.signType !== 3;
    },
    pdfVm() {
      return this.$refs.pdf;
    },
    curPdfFile() {
      const { fileList, curFileId } = this;
      return fileList.find(({ fileId }) => curFileId === fileId);
    },
    isBothBatch: {
      get() {
        return this.batchId.length === this.waitCopyList.length;
      },
      set(val) {
        this.batchId = val ? this.waitCopyList.map(({ fileId }) => fileId) : [];
      }
    },
    // 批量签章列表
    waitCopyList() {
      const { fileList, curFileId } = this;
      return fileList
        .filter(({ fileId }) => curFileId !== fileId)
        .map(({ fileId, fileName, sealList }) => ({
          fileId,
          fileName,
          hasSeal: !!sealList?.length
        }));
    }
  },
  async created() {
    if (!this.isWebPdfSign) {
      this.initFiles();
    }
  },
  destroyed() {
    cacheFn.cache.clear();
  },
  methods: {
    async initFiles(val) {
      const fileIds = this.$route.query.fileIds || val || "";
      if (!fileIds) {
        this.$error("参数错误，要签章的文件不能为空");
        return;
      }
      this.fileIdArray = fileIds.split(",");
      const res = await eSealService.queryFilesDetail(this.fileIdArray);
      const list = res.data || [];
      list.forEach((item) => (item.fileUrl = addParamToUrl(item.downloadUrl, "token", getToken())));
      this.fileList = list;
      this.curFileId = this.fileList[0]?.fileId || "";
      this.initPdfFile();
      this.queryStampList();
    },

    async initPdfFile() {
      this.signType = this.curPdfFile.signType || 3;
      this.pdfUrl = this.curPdfFile.fileUrl;
      await this.$nextTick();
      this.butDisabled = false;
    },
    async queryStampList() {
      const res = await eSealService.getAllElectronic(this.enterpriseId);
      const list = res.data || [];
      list.forEach((item) => {
        item.downloadUrl = addParamToUrl(item.downloadUrl, "token", getToken());
        item.src = item.downloadUrl;
        item.id = item.sortID;
        item.key = item.sortID;
        item.label = item.sortName;
        this.imageFileId = item.sortID;
      });
      this.sealList = list;
    },

    updateCurPdfSeal() {
      // 获取当前签章数据 处理到fileList中去
      this.curPdfFile.signType = this.signType;
      this.curPdfFile.sealList = this.getCurPdfSeal();
    },
    confirmBatch() {
      const { batchId, fileList } = this;
      if (!batchId.length) {
        return this.$message.warning("您没有选择批量处理的文件");
      }

      // 顺道将自己签章数据也更新了
      this.updateCurPdfSeal();
      const { sealList } = this.curPdfFile;
      if (!sealList.length) {
        return this.$message.warning("您当前页面没有选中任何签章");
      }

      // 将当前签章数据更新到选中的文件中去
      for (const item of fileList) {
        if (batchId.indexOf(item.fileId) > -1) {
          item.sealList = cloneDeep(sealList);
          item.signType = this.signType;
        }
      }
      this.$message.success("批量处理成功");
      this.closeBatch();
    },
    closeBatch() {
      this.showBatch = false;
    },
    openBatch() {
      this.batchId = [];
      this.showBatch = true;
    },
    getCurPdfSeal() {
      const vm = this.$refs.pdf;
      const sealList = [];
      const { stampList, sealList: list } = vm;
      const map = {};
      for (const stamp of stampList) {
        map[stamp.id] = stamp;
      }
      for (const seal of list) {
        const stamp = map[seal.imageFileId];
        const item = {
          ...seal,
          sealStrategyId: stamp?.sealStrategyId,
          sealsignTypeId: stamp?.sealsignTypeId,
          sealUserName: stamp?.sealUserName,
          sealUserId: stamp?.sealUserId,
          locationX: seal.locationX,
          locationY: seal.locationY,
          imageHeight: seal.imageHeight,
          imageWidth: seal.imageWidth,
          imageBase64: seal.imageBase64
        };
        sealList.push(item);
      }
      return sealList;
    },
    // 页面切换回调 - 切换页码
    onPageUpdate(vm) {
      const { onlyFirst } = this;
      if (onlyFirst) vm.pageTotal = 1;
      this.loading = false;
    },
    async setFileId(id) {
      const oldId = this.curFileId;
      if (id !== oldId) {
        // 缓存签章数据
        this.updateCurPdfSeal();
        this.loading = true;
        this.curFileId = id;
        await this.initPdfFile(id);
        this.$refs.pdf.pageIndex = 1;
        await this.$refs.pdf.updateVm();
        this.loading = false;
      }
    },

    // 切换签章策略
    async handleSealPositionChanged(val) {
      const { pdfVm: vm } = this;
      this.key++;
      if (vm.sealList.length) {
        try {
          await this.$confirm("切换签章策略将清空之前的签章数据,是否确定?", "警告", { type: "warning" });
        } catch (error) {
          this.key++;
          throw new Error("取消切换策略");
        }
      }
      this.signType = val;
      this.loading = true;
      this.curPdfFile.sealList = [];
      await vm.updateVm();
    },
    // 设置 自动排列签章的签章数据
    // 位置:签章图中心 到下和左的百分比
    getAutoFlowStamp() {
      return [];
    },
    // 获取默认展示数据  只显示第一页
    getCache() {
      const {
        onlyFirst,
        curPdfFile: { sealList: pdfOldCatch }
      } = this;
      let list = [];
      // 有旧数据直接用旧数据
      if (pdfOldCatch?.length) list = pdfOldCatch;
      // 如果是只需在首页操作 需要自动加载所有签章并排序
      else if (onlyFirst) list = this.getAutoFlowStamp();
      return JSON.stringify(list);
    },
    async queryStamp() {
      return this.sealList;
    },
    async getPdf() {
      return await cacheFn(this.pdfUrl).then((d) => d.slice());
    },
    async onSubmit(a, b, withCert) {
      if (!this.saveFolderId) {
        this.$message.error("请选择存放目录");
        return;
      }
      // 更新 当前页面签章数据
      this.updateCurPdfSeal();
      const fileList = this.fileList;
      const emptyList = fileList.filter(({ sealList }) => !sealList?.length);
      const emptyNum = emptyList.length;
      if (emptyNum) {
        const err = `${emptyList[0].fileName}${emptyNum > 1 ? `等${emptyNum}个文件` : ""} 没有签章`;
        this.$message.error(err);
        throw new Error(err);
      }
      await this.$confirm(`确定提交签章?`, "提醒");
      const list = fileList.map((pdfFile) => ({
        fileId: pdfFile.fileId,
        signType: pdfFile.signType,
        folderId: this.saveFolderId,
        prjId: this.projectId,
        withCert: withCert,
        sealList: this.convertToSealList(pdfFile.sealList)
      }));
      const res = await eSealService.commintPdfSignature(list);
      this.filesList = res.data;
      this.butDisabled = true;
      this.$message.success("提交成功");
      // 回调 CAD 的接口,主动关闭对话框
      if (window.closeWindow) {
        window.closeWindow();
      }
    },

    convertToSealList(sealList) {
      return sealList;
    },
    onLineFiles() {
      const { prjId, prjName } = this.prjInfo;
      const obj = this.filesList.filter(({ oldFileId }) => oldFileId === this.curFileId)[0];
      obj.folderId = obj.fileId;
      noLabelFilePreview(obj, prjId, prjName, "ct", "");
    },
    async toProjectDoc() {
      const obj = this.filesList.filter(({ oldFileId }) => oldFileId === this.curFileId)[0];
      const res = await flowService.getAssociatedFileLocation(obj.fileId);
      this.$store.dispatch("XtDesignUpdateNav", res.data);
      this.$router.push({
        path: "/project-XtDesign"
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-radio-group {
  display: block;
  margin: 14px 0 0;
  height: 20px;
}

.file-bar {
  position: absolute;
  top: 30px;
  left: 7px;
  right: 30px;
  height: 32px;
  background-color: #fff;
}

.sealPosition {
  margin-top: 40px;
  height: 30px;
  margin-bottom: 5px;
  margin-left: 5px;
}

.file-list {
  position: absolute;
  top: -3px;
  left: 0px;
  // left: 100px;
  right: -20px;
}

.seal-tag {
  color: #f00;
  padding: 0 2px;
  border: 1px solid;
  border-radius: 1px;
  margin: 0 4px 0;
}
</style>
